import React from 'react'

export default class Sentinel extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = { hasError: false }
  }

  componentDidCatch(error, info) {
    this.setState({ hasError: true })
    console.error(error, info, window.location.href)
  }

  render() {
    if (this.state.hasError) {
      return this.props.silent ? null : (
        <p class="error">Something unexpected happened.</p>
      )
    }
    return this.props.children
  }
}



// WEBPACK FOOTER //
// ./src/components/Sentinel.js